import type { IconProps } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

export function InvertableSentryIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <use href="#app-icon-invertable-sentry" />
    </Icon>
  );
}
